/**
 *  @class
 *  @function SwymWishlistInstance
 */
if (!customElements.get('swym-wishlist-instance')) {
  class SwymWishlistInstance extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.wishlistButton = this.querySelector('[data-swym-wishlist-instance-button]');

      if (!window.SwymCallbacks){
        window.SwymCallbacks = [];
      }
      window.SwymCallbacks.push(this.swymCallback.bind(this));
    }
    swymCallback() {
      if (this.wishlistButton) {
        _swat.fetchWrtEventTypeET(this.swymFetchEventsCallback.bind(this), 4);
      }
    }
    swymFetchEventsCallback(products) {
      let activeProductId = SwymPageData.empi;
      let activeVariantId = SwymPageData.epi;
      let foundActiveProductInWishlist = products.find((p) => p.empi == activeProductId && p.epi == activeVariantId);

      if (foundActiveProductInWishlist) {
        this.wishlistButton.classList.remove('atw-button-add');
        this.wishlistButton.classList.add('atw-button-added');
      }
      
      this.wishlistButton.addEventListener("click", function(e) {
        if (SwymPageData) {
          SwymPageData.et = 4;
          if (foundActiveProductInWishlist) {
            _swat.removeFromWishList(SwymPageData, function(e) {
              this.wishlistButton.classList.remove('atw-button-added');
              this.wishlistButton.classList.add('atw-button-add');
            }.bind(this));
          } else {
            _swat.addToWishList(SwymPageData, function(e) {
              this.wishlistButton.classList.remove('atw-button-add');
              this.wishlistButton.classList.add('atw-button-added');
            }.bind(this));
          }
          foundActiveProductInWishlist = !foundActiveProductInWishlist;
        }
      }.bind(this));
    }
  }
  customElements.define('swym-wishlist-instance', SwymWishlistInstance);
}